import { render, staticRenderFns } from "./contactCard.vue?vue&type=template&id=587f1e68&"
import script from "./contactCard.vue?vue&type=script&lang=js&"
export * from "./contactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports